/**
 * @param {string} videoId
 * @return {IterableIterator<*>}
 */
import { deleteVideoApi } from 'common/api/videos';
import { videoDeletedAction } from 'common/actions';
import { put } from 'redux-saga/effects';
import { hideDialogAction } from 'components/redux-dialog/actions';
import { DELETE_MY_VIDEO_DIALOG } from 'pages/my-videos.page/fragments';

export function* deleteVideoEffect({ payload }) {
  try {
    yield deleteVideoApi(payload.videoId);

    if (payload.confirm) {
      yield put(videoDeletedAction(payload.videoId));
      yield put(hideDialogAction(DELETE_MY_VIDEO_DIALOG));
    }
  } catch (error) {
    // here do nothing even if error happen - we don't care if deletion of video is success or no.
    // Backend to take care of it as per agreement
  }
}
